import { useGetEstateForTableQuery } from '@gql'

export const useEstateWithApplicationsAndVisitSpans = () => {
  const {
    data: estatesData,
    loading: estatesLoading,
    error: estatesError,
  } = useGetEstateForTableQuery()

  return {
    estates: estatesData?.estate ?? [],
    loading: estatesLoading,
    error: estatesError,
  }
}
